import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { Flowbite } from 'flowbite-react';
import customTheme from './utils/theme/custom-theme';
import FullLayout from './layouts/full/FullLayout';
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import Dashboard from './pages/dashboard/Dashboard';
import Users from './pages/users/Users';
import Map from './pages/map/Map';
import Analytics from './pages/analytics/Analytics';
import Settings from './pages/settings/Settings';
import Profile from './pages/profile/Profile';
import LandingPage from './pages/LandingPage';
import ForgotPassword from './pages/views/auth/forgot-password/page';
import ResetPassword from './pages/views/auth/reset-password/page';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './contexts/AuthContext';

const App: React.FC = () => {
  return (
    <ThemeProvider>
      <Flowbite theme={customTheme}>
        <Router>
          <AuthProvider>
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<LandingPage />} />
              <Route path="/landing" element={<LandingPage />} />
              <Route path="/auth/login" element={<Login />} />
              <Route path="/auth/register" element={<Register />} />
              <Route path="/auth/forgot-password" element={<ForgotPassword />} />
              <Route path="/auth/reset-password" element={<ResetPassword />} />

              {/* Protected Routes */}
              <Route path="/app" element={
                <ProtectedRoute>
                  <FullLayout />
                </ProtectedRoute>
              }>
                {/* Employer Routes */}
                <Route path="employer">
                  <Route element={<ProtectedRoute allowedUserTypes={['Employer']}><Outlet /></ProtectedRoute>}>
                    <Route path="dashboard" element={<Dashboard />} />
                    <Route path="profile" element={<Profile />} />
                    <Route path="settings" element={<Settings />} />
                  </Route>
                </Route>

                {/* Contractor Routes */}
                <Route path="contractor">
                  <Route element={<ProtectedRoute allowedUserTypes={['Contractor']}><Outlet /></ProtectedRoute>}>
                    <Route path="dashboard" element={<Dashboard />} />
                    <Route path="profile" element={<Profile />} />
                    <Route path="settings" element={<Settings />} />
                  </Route>
                </Route>

                {/* Admin Routes */}
                <Route path="admin">
                  <Route element={<ProtectedRoute allowedUserTypes={['Admin']}><Outlet /></ProtectedRoute>}>
                    <Route path="dashboard" element={<Dashboard />} />
                    <Route path="users" element={<Users />} />
                    <Route path="map" element={<Map />} />
                    <Route path="analytics" element={<Analytics />} />
                    <Route path="settings" element={<Settings />} />
                    <Route path="profile" element={<Profile />} />
                  </Route>
                </Route>
              </Route>

              {/* Catch all route - redirect to landing page */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </AuthProvider>
        </Router>
      </Flowbite>
    </ThemeProvider>
  );
};

export default App;
